import "./CompareEvaluation.css";
import { useTranslation } from "react-i18next";

function CompareEvaluation (props) {
    const { t } = useTranslation();

    //average Time
    let penAndPaperAverageMinutes = Math.floor(Math.round(props.averageResults.penAndPaperAverageTime) / 60)
    let penAndPaperAverageSeconds = Math.round(props.averageResults.penAndPaperAverageTime) % 60
    let deductionsAverageMinutes = Math.floor(Math.round(props.averageResults.deductionsAverageTime) / 60)
    let deductionsAverageSeconds = Math.round(props.averageResults.deductionsAverageTime) % 60
    let kpisAverageMinutes = Math.floor(Math.round(props.averageResults.kpisAverageTime) / 60)
    let kpisAverageSeconds = Math.round(props.averageResults.kpisAverageTime) % 60

    //Comparison texts
    let penAndPaperScoreText = `${t("same_average")}`;
    let penAndPaperTimeText = `${t("same_average")}`;
    let deductionsScoreText = `${t("same_average")}`;
    let deductionsTimeText = `${t("same_average")}`;
    let kpisScoreText = `${t("same_average")}`;
    let kpisTimeText = `${t("same_average")}`;

    if (props.penAndPaperScore > props.averageResults.penAndPaperAverageScore) {
        penAndPaperScoreText = `${t("above_average")}`;
    } else if (props.penAndPaperScore < props.averageResults.penAndPaperAverageScore) {
        penAndPaperScoreText = `${t("under_average")}`;
    }

    if (props.penAndPaperMinutes > penAndPaperAverageMinutes || (props.penAndPaperMinutes === penAndPaperAverageMinutes && props.penAndPaperSecondes > penAndPaperAverageSeconds)) {
        penAndPaperTimeText = `${t("above_average")}`;
    } else if (props.penAndPaperMinutes < penAndPaperAverageMinutes || (props.penAndPaperMinutes === penAndPaperAverageMinutes && props.penAndPaperSeconds < penAndPaperAverageSeconds)) {
        penAndPaperTimeText = `${t("under_average")}`;
    }

    if (props.deductionsScore > props.averageResults.deductionsAverageScore) {
        deductionsScoreText = `${t("above_average")}`;
    } else if (props.deductionsScore < props.averageResults.deductionsAverageScore) {
        deductionsScoreText = `${t("under_average")}`;
    }

    if (props.deductionsMinutes > deductionsAverageMinutes || (props.deductionsMinutes === deductionsAverageMinutes && props.deductionsSecondes > deductionsAverageSeconds)) {
        deductionsTimeText = `${t("above_average")}`;
    } else if (props.deductionsMinutes < deductionsAverageMinutes || (props.deductionsMinutes === deductionsAverageMinutes && props.deductionsSeconds < deductionsAverageSeconds)) {
        deductionsTimeText = `${t("under_average")}`;
    }

    if (props.kpisScore > props.averageResults.kpisAverageScore) {
        kpisScoreText = `${t("above_average")}`;
    } else if (props.kpisScore < props.averageResults.kpisAverageScore) {
        kpisScoreText = `${t("under_average")}`;
    }

    if (props.kpisMinutes > kpisAverageMinutes || (props.kpisMinutes === kpisAverageMinutes && props.kpisSecondes > kpisAverageSeconds)) {
        kpisTimeText = `${t("above_average")}`;
    } else if (props.kpisMinutes < kpisAverageMinutes || (props.kpisMinutes === kpisAverageMinutes && props.kpisSeconds < kpisAverageSeconds)) {
        kpisTimeText = `${t("under_average")}`;
    }

    return (
        <div className="container-sm compare-box">
            <h3>{t("average_results")}</h3>
            <div className="row average-results">
                <div className="col-sm compare-item">
                    <span>1. {t("pnp")}</span>
                    <p>
                        {t("average_score")} <span>{Math.round(props.averageResults.penAndPaperAverageScore)}</span> <br/> 
                        {penAndPaperScoreText}
                    </p>
                    <p>
                        {t("average_time")} <span><span>{penAndPaperAverageMinutes}</span><span>:</span><span>{(penAndPaperAverageSeconds === 0 || penAndPaperAverageSeconds < 10) ? ("0" + penAndPaperAverageSeconds) : penAndPaperAverageSeconds}</span></span> <br/>
                        {penAndPaperTimeText}
                    </p>
                </div>
                <div className="col-sm compare-item">
                    <span>2. {t("deductions")}</span>
                    <p>
                        {t("average_score")} <span>{Math.round(props.averageResults.deductionsAverageScore)}</span> <br/>
                        {deductionsScoreText}
                    </p>
                    <p>
                        {t("average_time")} <span><span>{deductionsAverageMinutes}</span><span>:</span><span>{(deductionsAverageSeconds === 0 || deductionsAverageSeconds < 10) ? ("0" + deductionsAverageSeconds) : deductionsAverageSeconds}</span></span> <br/>
                        {deductionsTimeText}
                    </p>
                </div>
                <div className="col-sm compare-item">
                    <span>3. {t("kpis")}</span>
                    <p>
                        {t("average_score")} <span>{Math.round(props.averageResults.kpisAverageScore)}</span> <br/>
                        {kpisScoreText}
                    </p>
                    <p>
                        {t("average_time")} <span><span>{kpisAverageMinutes}</span><span>:</span><span>{(kpisAverageSeconds === 0 || kpisAverageSeconds < 10) ? ("0" + kpisAverageSeconds) : kpisAverageSeconds}</span></span> <br/>
                        {kpisTimeText}
                    </p>
                </div>
            </div>
        </div>
    );
}

export default CompareEvaluation;